LN.CustomDimension = new (function (LocalStorage) {
    var self = this;
    var key = 'CustomDimension';
    var objCustomDimension = {};
    this.get = function () {
        objCustomDimension = LocalStorage.getItem(key);
        return objCustomDimension;
    }

    this.clear = function () {
        objCustomDimension = {};
        LocalStorage.removeItem(key);
    }

    this.set = function (prop, value) {
        if (!objCustomDimension) objCustomDimension = {};
        objCustomDimension[prop] = value;
        return objCustomDimension;
    }


    this.save = function () {
        LocalStorage.setItem(key, objCustomDimension);
    }

    this.exist = function () {
        return this.get() !== null;
    }



    this.setSuscriptorType = function (value) {
        this.set('suscriptorType', value);
    }
    this.setRegistrado = function (value) {
        this.set('usuarioRegistrado', value);
    }
    this.setUserId = function (value) {
        this.set('userId', value);
    }
})(LN.LocalStorage);


// WEBPACK FOOTER //
// ./Statics/scripts/common/customDimension.js